var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PropertyHeader',{attrs:{"header":'Attachments'},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('DesignerButton',{attrs:{"small":"","icon":'add',"tooltip":'Add attachment'}})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }